export const DataSourceUrl = {
  CONNECTIONS: '/data-sources/connections',
};
